/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLane = createReactComponent("outline", "lane", "IconLane", [["path", { "d": "M4 6v13", "key": "svg-0" }], ["path", { "d": "M20 6v13", "key": "svg-1" }]]);

export { IconLane as default };
//# sourceMappingURL=IconLane.mjs.map
